import { apiTryFetchRetry } from '@editor/utils/apiFetchRetry';

import { USER_API_URL } from './constants';
import { GetTagGroupsResponse, GetUseCasesResponse } from './templates';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const createAPI = ({ url }: { url: string }) => {
  // get all usecases
  const getUseCases = async (
    options?: RequestInit
  ): Promise<GetUseCasesResponse> => {
    return await apiTryFetchRetry<GetUseCasesResponse>(
      `${url}/usecase/all`,
      options
    );
  };

  // get all TagGroups
  const getTagGroups = async (
    minTemplates?: number,
    options?: RequestInit
  ): Promise<GetTagGroupsResponse> => {
    const params = minTemplates ? `?minTemplates=${minTemplates}` : '';

    return await apiTryFetchRetry<GetTagGroupsResponse>(
      `${url}/tags/groups/all${params}`,
      options
    );
  };

  return {
    getUseCases,
    getTagGroups,
  };
};

const useCaseApi = createAPI({ url: `${USER_API_URL}/templates` });
export default useCaseApi;
